import React from "react";
import { Select, Form, Input, Checkbox, InputNumber } from "antd";
import {
  currenciesSelect as currencies,
  orderTypes as orderTypesTypesDict,
  packageTypes,
  transformToSelect,
} from "../../constants/transport";
import validations from "../../utils/validations";
import FloatingField from "../common/FloatingField";

const { TextArea } = Input;

const orderTypes = transformToSelect(orderTypesTypesDict);

const Info = ({ form, order, duplicate, watchedValues = {} }) => {
  return (
    <>
      <div className="order-form__section__title">
        <span className="order-form__section__title__text">О грузе</span>
      </div>
      <div className="transport-search-form__row transport-search-form__row--stack-mobile">
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item
            rules={[validations.required]}
            name="type"
            label="Характер груза"
          >
            <FloatingField label="*Характер груза" active={watchedValues.type}>
              <Select
                placeholder=""
                options={orderTypes}
                size="large"
              />
            </FloatingField>
          </Form.Item>
        </div>
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item
            rules={[validations.required]}
            name="package_type"
            label="*Вид упаковки"
          >
            <FloatingField label="*Вид упаковки" active={watchedValues.package_type}>
              <Select
                placeholder=""
                options={packageTypes}
                size="large"
              />
            </FloatingField>
          </Form.Item>
        </div>
      </div>
      <div className="transport-search-form__row transport-search-form__row--stack-mobile">
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item
            rules={[validations.required]}
            name="weight"
            label="Вес (тонн)*"
          >
            <FloatingField label="*Вес (тонн)" active={watchedValues.weight}>
              <Input
                prefix=""
                type="number"
                size="large"
                className="suffix-input height-44"
              />
            </FloatingField>
          </Form.Item>
        </div>
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item
            rules={[validations.required]}
            name="volume"
            label="Объём (м3)*"
          >
            <FloatingField label="*Объём (м3)" active={watchedValues.volume}>
              <Input
                prefix=""
                type="number"
                size="large"
                className="suffix-input height-44"
              />
            </FloatingField>
          </Form.Item>
        </div>
      </div>
      <div className="order-form__section__row order-form__section__row--triple">
        <Form.Item name="length" label="Длина (м)">
          <FloatingField label="Длина (м)" active={watchedValues.length}>
            <Input
              prefix=""
              type="number"
              size="large"
              className="suffix-input height-44"
            />
          </FloatingField>
        </Form.Item>
        <Form.Item name="width" label="Ширина (м)">
          <FloatingField label="Ширина (м)" active={watchedValues.width}>
            <Input
              prefix=""
              type="number"
              size="large"
              className="suffix-input height-44"
            />
          </FloatingField>
        </Form.Item>
        <Form.Item name="height" label="Высота (м)">
          <FloatingField label="Высота (м)" active={watchedValues.height}>
            <Input
              prefix=""
              type="number"
              size="large"
              className="suffix-input height-44"
            />
          </FloatingField>
        </Form.Item>
      </div>
      <div className="transport-search-form__row transport-search-form__row--stack-mobile">
        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item name="temperature" valuePropName="checked">
            <Checkbox>
              Температурный режим
            </Checkbox>
          </Form.Item>

          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.temperature !== currentValues.temperature}>
            {({ getFieldValue }) => getFieldValue("temperature") ? (
              <div
                className="transport-search-form__row two"
                style={{ marginTop: "-15px" }}
              >
                <div className="transport-search-form__row transport-search-form__row--child-full">
                  <Form.Item
                    name="temperature_min"
                    rules={[validations.required]}
                  >
                    <InputNumber
                      size="large"
                      placeholder="Мин., °C"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
                <div className="transport-search-form__row transport-search-form__row--child-full">
                  <Form.Item
                    name="temperature_max"
                    rules={[validations.required]}
                  >
                    <InputNumber
                      size="large"
                      placeholder="Макс., °C"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </div>
              </div>
            ) : null}
          </Form.Item>
        </div>

        <div
          className="transport-search-form__row transport-search-form__row--child-full"
          style={{ flexDirection: "column" }}
        >
          <Form.Item name="cargo_price_require" valuePropName="checked">
            <Checkbox>
              Указать стоимость груза
            </Checkbox>
          </Form.Item>

          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.cargo_price_require !== currentValues.cargo_price_require}>
            {({ getFieldValue }) => getFieldValue("cargo_price_require") ? (
              <div
                className="transport-search-form__row two"
                style={{ marginTop: "-15px" }}
              >
                <div className="transport-search-form__row transport-search-form__row--child-full">
                  <Form.Item name="cargo_price" rules={[validations.required]}>
                    <Input
                      placeholder="Сумма?"
                      type="number"
                      size="large"
                      className="height-44"
                    />
                  </Form.Item>
                </div>
                <div className="transport-search-form__row transport-search-form__row--child-full">
                  <Form.Item
                    name="cargo_price_currency"
                    rules={[validations.required]}
                  >
                    <Select
                      placeholder="Валюта*"
                      size="large"
                      style={{ width: "100%" }}
                      optionLabelProp="customLabel"
                    >
                      {currencies.map((currency) => (
                        <Select.Option
                          key={currency.value}
                          value={currency.value}
                          customLabel={
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={`/img/${currency.icon}.png`}
                                alt={currency.label}
                                style={{ width: "20px", marginRight: "8px" }}
                              />
                              {currency.label}
                            </div>
                          }
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={`/img/${currency.icon}.png`}
                              alt={currency.label}
                              style={{ width: "20px", marginRight: "8px" }}
                            />
                            {currency.label}
                          </div>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            ) : null}
          </Form.Item>
        </div>
      </div>
      <div className="order-form__section__title">
        <span className="order-form__section__title__text">Примечание</span>
      </div>
      <Form.Item name="comment">
        <FloatingField
          label="Что стоит учесть перевозчику?"
          active={watchedValues.comment}
          className="floating-field--textarea"
        >
          <TextArea
            rows={4}
            placeholder=""
            maxLength={500}
          />
        </FloatingField>
      </Form.Item>
      {/* <Form.Item
        name='additional_load'
        label='Тип перевозки'
        rules={[validations.required]}
      >
        <Select placeholder='Вид загрузки' options={addiotionLaods} onChange={onChange} size='large' />
      </Form.Item>
      {form.getFieldValue('additional_load') == 1 && <Form.Item
        name='count_of_transport'
        label='Количество машин'
        rules={[validations.required]}
      >
        <Input placeholder='Количество машин' type='number' disabled={form.getFieldValue('additional_load') == 2} size='large' />
      </Form.Item>} */}
    </>
  );
};

export default Info;
